import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getNavigationLinks, NavigationLinkConfig } from './navigation-links';

export const Navigation: React.FC = () => {
  const location = useLocation();
  const links = getNavigationLinks();

  return (
    <nav
      className="flex flex-wrap gap-3 lg:gap-5"
      aria-label="Primary navigation"
    >
      {links.map((link: NavigationLinkConfig) => {
        const isActive = link.isActive(location.pathname);
        const isHome = link.id === 'home';

        return (
          <Link
            key={link.id}
            to={link.path}
            className={`transition-colors text-sm lg:text-base ${
              isActive ? 'text-white hover:text-red-400' : 'text-slate-200 hover:text-white'
            }`}
            style={
              isHome
                ? {
                    color: isActive
                      ? 'var(--theme-text-primary)'
                      : 'var(--theme-text-secondary)',
                  }
                : undefined
            }
            aria-current={isActive ? 'page' : undefined}
          >
            {link.label}
          </Link>
        );
      })}
    </nav>
  );
};
